import React from "react";
import './loader-circle.css'

export default function Loader() {
  return (
    <div className="loader-container">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        </div>
      </div>
    )
}
